import { CardCustom } from '@ingenico/react-ui/card-custom';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import type { PropsWithChildren, ReactNode } from 'react';
import type { CoreCardWithLabelProps } from './coreCardWithLabel.model';
import styles from './coreCardWithLabel.module.scss';

export function CoreCardWithLabel({ children, title }: PropsWithChildren<CoreCardWithLabelProps>): ReactNode {
  return (
    <CardCustom className={styles.container}>
      <CoreTypography variant={CoreTypographyVariant.Title02Bold}>{title}</CoreTypography>
      {children}
    </CardCustom>
  );
}
